import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { initialLoadThunk, updateCurrentPositionThunk, userSetsSectionThunk } from "../store/thunks";
import Routes from "./Routes";
import { useHistory, useLocation } from "react-router";
import i18n from "../i18n";
import Loading from "./common/Loading";
import { toggleSidebar } from "../store/actions";
import { getLanguage, persistDeeplink } from "../store/persistStore";
import { initTokenRefreshListeners } from "./auth/tokenRefreshService";

initTokenRefreshListeners();

const App = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loaded, setLoaded] = useState(false);
  const resources = useSelector((state) => state.languages);
  const location = useLocation();
  const [deeplinks, setDeeplinks] = useState(null);
  const currentSection = useSelector((state) => state.progress.section);
  useEffect(() => {
    if (deeplinks === null) {
      location.pathname!=='/signin-oidc' && location.pathname!=='/app' && location.pathname!=='/login' && setDeeplinks(location.pathname);
    }
    else {
      location.pathname!=='/signin-oidc' && location.pathname!=='/login' && persistDeeplink(deeplinks)
    }
  }, [location.pathname, deeplinks]);

  useEffect(() => {
    const load = async () => {
      return dispatch(initialLoadThunk());
    };
    load().then((progress) => {
      setLoaded(true);
      if (progress.section === "") {
        if (!progress.termsAccepted) {
          return history.push("/terms");
        }

        // terms are accepted but assessment is not finished yet
        if (progress.termsAccepted && !progress.assessmentDone) {
          return history.push("/app/activity/assessment");
        }

        // User went through all intros - redirect to last position in application
        if (progress.termsAccepted && progress.assessmentDone) {
          if (window.innerWidth < 415) {
            dispatch(toggleSidebar());
          }
          const sectionName = "waterfall";
          return history.push(
            progress.currentPosition[getLanguage()][sectionName + "Path"]
          );
        }
        // history.push("/app/activity/assessment");
      }
    });
  }, []);
  const updateSectionifNeeded = async (path) =>{
    if (currentSection === "PMAgile") {
      if (!path.includes('agile')) {
        await dispatch(userSetsSectionThunk('PMWaterfall'));
        await dispatch(updateCurrentPositionThunk(path));
      }
    }
    else if (currentSection === "PMWaterfall"){
      if (path.includes('agile')) {
        await dispatch(userSetsSectionThunk('PMAgile'));
        await dispatch(updateCurrentPositionThunk(path));
      }
    }
  }
  useEffect(()=>{
    const safeURL = ['/logout','/app/earn-badges','/login','/signin-oidc','/app','/progress','/app/key-terms','/app/good-questions','/app/tools-and-templates','/app/pages/about-us','/@dmnt33111l','/app/congratulations']
    if (!safeURL.includes(history.location.pathname) && !history.location.pathname.includes('/app/key-terms/')) {
      updateSectionifNeeded(history.location.pathname)
  }
  },[history.location.pathname,currentSection])

  useEffect(() => {
    _.forEach((val, key) => {
      i18n.addResourceBundle(key, "translation", val);
    });
  }, [resources]);

  return <div>{loaded ? <Routes /> : <Loading />}</div>;
};

export default App;
